module.exports = __webpack_public_path__ + "img/ball_4_orange.28e8eafc.png";